module.exports = require("brace/snippets/mysql");